import type {
    ReminderScheduleNotificationMarkReadAll,
    ReminderScheduleNotificationResponse,
} from '@/types/apps/reminder-schedule-notification.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export interface ReminderScheduleNotificationServiceInterface {}

type ReminderScheduleNotificationListResponse = ApiResponse<
    PaginatedResult<ReminderScheduleNotificationResponse>
>;

export class ReminderScheduleNotificationService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/reminder-schedule-notification',
        markAsRead: () =>
            '/api/reminder-schedule-notification/mark-notification-as-read',
    };

    public index(
        params?: QueryParams
    ): Promise<ReminderScheduleNotificationListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public markAsRead(
        payload: ReminderScheduleNotificationMarkReadAll
    ): Promise<ApiResponse<ReminderScheduleNotificationListResponse>> {
        return this.apiClient.postApi(this.endpoints.markAsRead(), payload);
    }
}
